var render = function render(){var _vm=this,_c=_vm._self._c;return (!this.button.disabled)?_c('button',{staticClass:"btnCustomIconButton",attrs:{"disabled":!!this.button.disabled,"type":"button"},on:{"click":_vm.onCustomIconButton}},[_c('svg-sprite',{style:(`color: ${_vm.color}`),attrs:{"width":_vm.width,"height":_vm.height,"icon-id":_vm.icon}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }